export default "__VITE_ASSET__cdecd4c9__"